import enumsDatetime from '../enums/datetime';
import objectOf from '../general/objectOf';

// ----------------------------------------------------------------------------

function format(str: any, input?: string): any {
    if (!['Number', 'Object', 'String'].includes(objectOf(str))) {
        return str;
    }

    // If there is property date
    if (str.date) {
        str = str.date;
    }

    // ------------------------------------------------------------------------

    // If there is moment
    if (typeof (window as any).moment !== 'undefined') {
        const moment = (window as any).moment;

        //
        const date = new Date(str);

        //
        str = moment(date.valueOf()).format(input ?? enumsDatetime.dateTimeSecondsFormat);
    }

    // ------------------------------------------------------------------------

    //
    return str;
}

// ----------------------------------------------------------------------------

export { format };
